<template>
  <div>
    <div class="qrImg">
      <img
        :src="require('./../../assets/QR.jpg')"
        style="width: 63vw; height: 63vw"
      />
      <p>扫一扫上面的二维码，联系顾问进行咨询</p>
    </div>
    <!-- <div class="vip_head">
      <p>会员信息</p>
      <img src="../../assets/close_vip.png" class="close" @click="closePage" />
    </div>
    <div class="vip_info">
      <div class="tel">
        <p>*手机号</p>
        <input type="tel" maxlength="11" v-model="tel" placeholder="请输入您的手机号" />
      </div>
      <div class="name">
        <p>*姓名</p>
        <input type="text" v-model="name" placeholder="请输入您的姓名" />
      </div>
      <div class="career">
        <p>职业</p>
        <input type="text" v-model="career" placeholder="请输入您的职业" />
      </div>
      <div class="gender">
        <p>性别</p>
        <select v-model="gender">
          <option value="0">女</option>
          <option value="1">男</option>
          <option value="2">保密</option>
        </select>
      </div>
    </div>
    <div class="submit_btn">
      <button type="button" @click="submit">信息提交</button>
    </div>
    <p style="color: red;" v-show="p1">带*号为必填信息</p>
    <p style="color: red;" v-show="p2">请输入正确的手机号</p>
    <p style="color: green;" v-show="p3">恭喜您成功注册PanBrain会员</p>
    <p style="color: green;" v-show="p4">您已是PanBrain会员</p> -->
  </div>
</template>

<script>
import { setInfo } from "@/http/api";
import axios from "axios";

export default {
  data() {
    return {
      name: "",
      gender: 2,
      career: "",
      birthday: null,
      tel: "",
      channel: "offline",
      p1: false,
      p2: false,
      p3: false,
      p4: false,
    };
  },
  methods: {
    submit() {
      if (this.tel == "" || this.name == "") {
        this.p1 = true;
        this.p2 = false;
        this.p3 = false;
        this.p4 = false;
      } else if (/^1[3|4|5|7|8][0-9]{9}$/.test(this.tel) == false) {
        this.p2 = true;
        this.p1 = false;
        this.p3 = false;
        this.p4 = false;
      } else {
        axios
          .post(
            "https://api.coolbrainscience.cn/release/egg/v2/inside-register",
            {
              nickname: this.name,
              gender: this.gender,
              profession: this.career,
              birthday: this.birthday,
              tel: this.tel,
              channel: this.channel,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Ticket: "7a694cfd-ae9c-43d2-aa12-7b89f77d3821",
              },
            }
          )
          .then((res) => {
            this.p3 = true;
            this.p1 = false;
            this.p2 = false;
            this.p4 = false;
          })
          .catch((error) => {
            this.p4 = true;
            this.p1 = false;
            this.p2 = false;
            this.p3 = false;
          });
      }
    },
    closePage() {
      let browser = navigator.userAgent.toLowerCase();
      if (browser.match(/Alipay/i) == "alipay") {
        console.log("支付宝app的浏览器");
        document.addEventListener(
          "AlipayJSBridgeReady",
          function () {
            AlipayJSBridge.call("closeWindow");
          },
          false
        );
        AlipayJSBridge.call("closeWebview");
      } else if (browser.match(/MicroMessenger/i) == "micromessenger") {
        document.addEventListener(
          "WeixinJSBridgeReady",
          function () {
            WeixinJSBridge.call("closeWindow");
          },
          false
        );
        WeixinJSBridge.call("closeWindow");
      } else {
        console.log("其他浏览器");
        window.opener = null;
        // window.open('', '_self', '')
        window.open("about:blank", "_self");
        window.close();
      }
    },
  },
};
</script>

<style scoped>
.qrImg {
  position: absolute;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  text-align: center;
}

.vip_head {
  width: 100vw;
  height: 86vw;
  /* background: url(../../assets/vip.png) no-repeat; */
  /* background-size: 100% 100%; */
  text-align: center;
  color: #2a2a2a;
  font-size: 4.8vw;
  font-family: "SourceHanSansCN-Medium";
  font-weight: 500;
  line-height: 11.7vw;
}

.close {
  width: 6.4vw;
  height: 6.4vw;
  position: absolute;
  top: 2.67vw;
  left: 4.8vw;
}

.vip_info {
  margin-top: 3.2vw;
}

.vip_info p {
  font-size: 4.3vw;
  color: #2a2a2a;
  font-family: "SourceHanSansCN-Regular";
  line-height: 13vw;
  position: absolute;
  left: 4.8vw;
}

.vip_info input,
.vip_info select {
  color: #9b9b9b;
  font-size: 4.3vw;
  font-family: "SourceHanSansCN-Regular";
  text-align: right;
  position: absolute;
  right: 8vw;
  line-height: 13vw;
  outline: none;
  border: none;
  top: 50%;
  transform: translateY(-50%);
}

.tel,
.name,
.career,
.gender {
  width: 100vw;
  height: 13vw;
  border-bottom: 1px solid #f0f1fc;
  position: relative;
}

.submit_btn {
  margin-top: 13.3vw;
  text-align: center;
}

.submit_btn button {
  background-color: #888ef9;
  border-radius: 6.67vw;
  width: 82.3vw;
  height: 13.3vw;
  border: none;
  font-size: 4.3vw;
  color: #ffffff;
  font-family: "SourceHanSansCN-Medium";
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Member.vue